// extracted by mini-css-extract-plugin
export default {"page_rapper":"centered-page-container_page_rapper__4oGfJ","page_container":"centered-page-container_page_container__GlH5H"};